import { TICKET_STATUS, MODIFIER_NICK_NAME } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'statement',
  standalone: true,
})
export class StatementPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value?: any, type?: string): string {
    if (!value) return '';

    let data: string = '';

    switch(type) {
      case 'date': {
        data = value?.Timestamp.includes('Z')
          ? moment(value?.Timestamp).format('MM/DD/YYYY hh:mm A')
          : moment(value?.Timestamp + 'Z').format('MM/DD/YYYY hh:mm A');
        break;
      };
      case 'formatDate': {
        data = moment(value).format("MM/DD/YYYY h:mm A");
        break;
      };
      case 'status': {
        data = (() => {
          let accountTicketStatus = '';

          if (value.EntityType === 'ticket' || value.EntityType === 'stackedticket') {
            accountTicketStatus = value.IsCancelled
              ? "Cancelled"
              : value.IsError
                ? "Error In Sell"
                : TICKET_STATUS[value.TicketStatus];
            accountTicketStatus = (accountTicketStatus === "Final" ? "Reconciled" : accountTicketStatus) ;
          }
          else if(value.EntityType === 'deposit') accountTicketStatus = "Deposit";
          else if(value.EntityType === 'withdrawal') accountTicketStatus = "Withdrawal";

          return accountTicketStatus;
        })();
        break;
      };
      case 'pool': {
        data = (() => {
          const accountTicketMod = value.Modifier;

          return (value.PoolId)
            ? value.PoolId
            : (accountTicketMod === 'None' || !accountTicketMod)
              ? ''
              : (MODIFIER_NICK_NAME as any)[accountTicketMod];
        })();

        break;
      };
      case 'debit': {
        data = (() => {
          const accountTicketAmount = 0;

          if (value.EntityType === 'ticket' || value.EntityType === 'stackedticket')
            return value.IsCancelled
              || value.IsError
              || (value.ToteTicketId && value.ToteTicketId.length > 11)
              || value.TicketStatus == '1'
                ? this.formatAmount('0')
                : this.formatAmount(value.TicketAmount);
          else if (value.EntityType === 'withdrawal')
            return this.formatAmount(value.TicketAmount);

          return this.formatAmount(String(accountTicketAmount));
        })();

        break;
      };
      case 'credit': {
        data = (() => {
          const won = 0;

          if (value.EntityType === 'ticket' || value.EntityType === 'stackedticket') {
            const accountTicketAmount = value.IsCancelled
              || value.IsError
              || (value.ToteTicketId && value.ToteTicketId.length > 11)
              || value.TicketStatus == '1'
                ? this.formatAmount('0')
                : this.formatAmount(value.TicketAmount);

            return value.IsCancelled
              || value.IsError
              || (value.ToteTicketId && value.ToteTicketId.length > 11)
              || value.TicketStatus == '1'
                ? accountTicketAmount
                : this.formatAmount(value.NetPayOff);
          }
          else if (value.EntityType === 'deposit') return this.formatAmount(value.BaseAmount);

          return this.formatAmount(String(won));
        })();

        break;
      };
      case 'pl': {
        data = (() => {
          const profitLoss = 0;

          if (value.EntityType === 'ticket' || value.EntityType === 'stackedticket') {
            return value.IsCancelled
              || value.IsError
              || (value.ToteTicketId && value.ToteTicketId.length > 11)
              || value.TicketStatus == '1'
                ? this.formatAmount('0')
                : this.formatAmount(String(parseFloat(value.NetPayOff) - parseFloat(value.TicketAmount)));
          }

          return this.formatAmount(String(profitLoss));
        })();

        break;
      };
    }

   return data;
  }

  formatAmount(value: string): string{
    const temp = parseFloat(value).toFixed(2);
    return '$' + temp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

}
